import React from "react";
import "./Footer.css";

import footer_logo from "../Assets/geckoonawall_mono.png";
import instagram_icon from "../Assets/Instagram_icon.png";

const Footer = () => {
  const instagram = () => {
    window.open("https://www.instagram.com/gecko.onawall/", "_blank");
  };

  return (
    <div className="footer">
        <div className="footer-left"></div>
      <div className="footer-center">
        <div className="footer-name">
          <h3>Gecko On A Wall</h3>
        </div>
        <button className="footer-socials" onClick={instagram}>
          <img src={instagram_icon} alt="" />
        </button>
        <div className="footer-copyright">
          <p>Copyright &copy; 2026 Gecko on a Wall - All Rights Reserved.</p>
        </div>
      </div>
      <div className="footer-right">
        <a href="https://youtu.be/dQw4w9WgXcQ?si=gLm7ASzllx-4c2Ec" target="_blank" rel="noopener noreferrer">
          <img src={footer_logo} alt="" />
        </a>
      </div>
    </div>
  );
};

export default Footer;
